import { useRef, useState, useCallback } from "react";
import { motion } from "framer-motion";
import useMotionPreferences from "@/hooks/useMotionPreferences";
import { SPRING } from "@/lib/motionSystem";

/**
 * Magnet — Magnetic hover effect on buttons. Button pulls toward cursor.
 * Inspired by React Bits Magnet component.
 */
export default function Magnet({ children, className = "", strength = 0.3, ...props }) {
  const ref = useRef(null);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const { allowDecorativeEffects } = useMotionPreferences();

  const handleMouseMove = useCallback((e) => {
    if (!allowDecorativeEffects) return;
    if (!ref.current) return;
    const rect = ref.current.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;
    const deltaX = (e.clientX - centerX) * strength;
    const deltaY = (e.clientY - centerY) * strength;
    setPosition({ x: deltaX, y: deltaY });
  }, [allowDecorativeEffects, strength]);

  const handleMouseLeave = useCallback(() => {
    setPosition({ x: 0, y: 0 });
  }, []);

  return (
    <motion.div
      ref={ref}
      className={`inline-block ${className}`}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      animate={{ x: position.x, y: position.y }}
      transition={SPRING.medium}
      {...props}
    >
      {children}
    </motion.div>
  );
}
